import React from "react";

const ITEMS = [
  "Downhole Fishing",
  "Milling & Underreaming",
  "Casing Exit Systems",
  "Chart Torquing",
  "Certified Equipment Racks",
  "Fabrication",
  "PBL Bypass Systems",
  "Rental Tools",
  "Wellbore Intervention",
];

/**
 * Continuous capability ticker. The list is rendered twice so the -50%
 * translation loops seamlessly.
 */
export default function Marquee() {
  return (
    <div className="relative border-y border-white/10 bg-ink-900 py-5">
      <div className="edge-fade flex overflow-hidden">
        <div className="flex shrink-0 animate-marquee items-center gap-10 pr-10">
          {[...ITEMS, ...ITEMS].map((item, i) => (
            <span
              key={`${item}-${i}`}
              className="flex shrink-0 items-center gap-10 font-display text-xl uppercase tracking-wide text-steel-400"
            >
              {item}
              <span className="text-flame-500" aria-hidden="true">
                ◆
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
